// @flow
import { connect } from 'react-redux';

import { fetchBillingDetailsRequest } from 'redux/Machine/actions';
import { stats } from 'redux/Machine/selectors';
import { getUserName } from 'redux/User/selectors';
import Dashboard from './Dashboard.component';
import type { DispatchPropsType, StatePropsType } from './Dashboard.component';

const mapStateToProps = (state: StoreType): StatePropsType => ({
  stats: stats(state),
  userName: getUserName(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  fetchBillingDetailsRequest: () => dispatch(fetchBillingDetailsRequest()),
});

export default (connect(mapStateToProps, mapDispatchToProps)(Dashboard): any);
